module.exports = __webpack_public_path__ + "img/home2.fd1a1618.png";